import React from 'react';
import { Users, Eye, Heart, MapPin } from 'lucide-react';
import { stats } from '../mock';

const iconMap = {
  users: Users,
  eye: Eye,
  heart: Heart,
  'map-pin': MapPin
};

const StatsSection = () => {
  return (
    <section className="py-20 bg-[#0F172A] relative overflow-hidden">
      {/* Background Effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0F0D] via-[#0F172A] to-[#0A0F0D] opacity-50"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Millions of Views. <span className="text-[#22C55E]">Real Conversions.</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Numbers that prove results. Performance that drives growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const Icon = iconMap[stat.icon];
            return (
              <div 
                key={index}
                className="bg-[#0A0F0D] border border-[#22C55E]/20 rounded-xl p-8 text-center transform transition-all duration-300 hover:scale-105 hover:border-[#22C55E] hover:shadow-lg hover:shadow-[#22C55E]/20 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex justify-center mb-4">
                  <div className="p-4 bg-[#22C55E]/10 rounded-full">
                    <Icon className="h-8 w-8 text-[#22C55E]" />
                  </div>
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white mb-2 stat-counter">
                  {stat.value}
                </div>
                <div className="text-[#94A3B8] font-medium">
                  {stat.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;